import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BarRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${Spacing.S8};
`

export const Spacer = styled.div`
  flex: 1;
`
